import { ConfigService, AppConfig } from '../services/config/config.service';
import { MatomoInitializerService } from 'ngx-matomo-client';

export function initializeMatomo(configService: ConfigService, matomoInitializer: MatomoInitializerService) {
  return (): Promise<void> =>
    configService
      .loadAppConfig()
      .then((data: AppConfig) => {
        return matomoInitializer.initializeTracker(data.matomo.config);
      })
      .catch((error) => console.error('Error in Matomo comp', error));
}
